import { render, staticRenderFns } from "./DiscountOptionUsedConfigModal.vue?vue&type=template&id=84d0dc5c&scoped=true&"
import script from "./DiscountOptionUsedConfigModal.vue?vue&type=script&lang=js&"
export * from "./DiscountOptionUsedConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./DiscountOptionUsedConfigModal.vue?vue&type=style&index=0&id=84d0dc5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d0dc5c",
  null
  
)

export default component.exports